export enum QuestionnaireFieldType {
  text = 'TEXT',
  number = 'NUMBER',
  dropdown = 'DROPDOWN',
  radio = 'RADIO',
  checkbox = 'CHECKBOX',
  toggle = 'TOGGLE',
  date = 'DATE',
  table = 'TABLE',
  searchDropdown = 'SEARCHDROPDOWN',
  summary = 'SUMMARY',
  hyperlink = 'HYPERLINK',
  staticText = 'STATICTEXT',
}